<template>
  <v-dialog v-model="dialog" persistent max-width="450px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>追加予約</v-toolbar>
        <v-card-title class="noPaddingBtm">
          <v-col cols="7" class="noPadding">
            {{this.viewTime}}
          </v-col>
        </v-card-title>
        <v-card-text>     
          <v-card-text>
            <v-container style="height: 216px;overflow-y: auto;">
              <v-row v-for="(item, index) in contentValue" :key="index">
                <v-col cols="7">
                  <v-subheader :style="GetBgRGB(index)">
                    <div class="MenuStyle">
                      {{item.menu == "" || item.menu == null ? item.meal_name : item.menu}}
                    </div>
                  </v-subheader>
                </v-col>
                <v-col cols="5" style="padding: 12px 0px;">
                  <v-subheader>
                    <v-card-actions>
                      <v-btn class="white--text" medium fab color="primary" @click="addReserve(index)" :disabled="!item.offer_flg_mc || item.reserve_flg == 0">{{item.additional_num}}</v-btn>
                    </v-card-actions>
                  </v-subheader>                  
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'">
            </ryou-black-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";

  export default {
    name: "MealReserveChangeNumDialog",
    components: {
      RyouBlackBtn
    },
    data() {
      return {
        dialog: false,
        closeBtnCtrl: false,      
        viewTime: "",

        contentValue: [],
        buildGroupId: "",
        reserveUserId: "",
        time: "",
      };
    },
    watch: {
    },
    methods: {
      //クリックを閉じる
      handleCancel() {
        this.close();
      },
      close() {
        this.dialog = false;
      },
      open() {
        this.dialog = true;
      },
      getInputValue(value, buildGroupId, reserveUserId,inputDate)
      {
        this.contentValue = value
        this.buildGroupId = buildGroupId
        this.reserveUserId = reserveUserId
        this.time = inputDate
        this.open();
      },
      //追加予約数を変更
      addReserve(index)
      {
        //値の範囲は 0～4
        if (this.contentValue[index].additional_num == 4) {
          this.contentValue[index].additional_num = 0
        } else {
          this.contentValue[index].additional_num++
        }
        this.handleOk(index)
      },
      //追加予約数更新
      handleOk(index) {

        let reserve_entity = {
          meal_class: this.contentValue[index].meal_class,
          additional_num: this.contentValue[index].additional_num
        }
        let params = {
          loginUserId: this.$store.getters.getUserId,
          build_group_id: this.buildGroupId,
          input_date: this.time,
          edit_user_id: this.reserveUserId,
          reserve_entity: reserve_entity
        }

        this.putRequest("/mealReservation/mealReserveNumUpdate", params, this.$store.getters.getUserToken).then((resp) => {
          if (!resp.success) {
            //更新失敗の場合は値を戻す
            if (this.contentValue[index].additional_num == 0) {
              this.contentValue[index].additional_num = 4
            } else {
              this.contentValue[index].additional_num--
            }
          }
        });
      },
      GetBgRGB(value) {
        let BgRGB = [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ]
        if (!this.contentValue[value].offer_flg_mc) {
          return {
            background: "#bebebe"
          }
        } else {
          return {
            background: BgRGB[value]
          };
        }
      },
    }
  }
</script>

<style scoped>
  .noPadding {
    padding: 0px;
  }

  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .noPaddingTopBtm {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .HigotoTextBox {
    outline: 1px solid rgb(0, 225, 255);
  }

  .MenuStyle {
    width: 100%;
    height: 100%;
    color: white;
    font-weight: bold;
    text-align: center;
    line-height: 48px;
  }
</style>